export enum VipSurface {
    AccountSettings = 'Account Settings',
    WelcomeModal = 'Welcome Modal',
}
